// Reuse your existing configured client to avoid duplicating URL/keys.
import { supabase as existingClient } from "@/integrations/supabase/client";
import type { SupabaseClient } from "@supabase/supabase-js";

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) client = existingClient;
  return client;
}